module.exports = __webpack_public_path__ + "images/park-west-5b8b49175ea321739fc0fe018cff4096.jpg";